<template>
  <el-card>
    <div
      slot="header"
      class="clearfix"
    >
      <span>Raktárközi szállítólevelek</span>
    </div>
    <div v-loading="loading" style="min-height: 81px;">
      <table-filter
        v-if="filterConfig"
        :config="filterConfig"
        action="representativeDelivery/fetchAll"
      />
    </div>
    <representative-delivery-list></representative-delivery-list>
  </el-card>
</template>

<script>
  import representativeDeliveryList from '../../components/sales/representativeDeliveries/List';
  import TableFilter from '../../components/TableFilter';

  export default {
    components: {
      representativeDeliveryList,
      TableFilter,
    },
    data() {
      return {
        loading: false,
        filterConfig: null,
      };
    },
    async mounted() {
      this.loading = true;

      await this.setConfig();
      this.loading = false;
    },
    methods: {
      async setConfig() {
        let users = this.$store.getters['user/users'];
        if (!users.length) {
          await this.$store.dispatch('user/fetchAll');
          users = this.$store.getters['user/users'];
        }

        this.filterConfig = [
          {
            type: 'text',
            name: 'receipt_number',
            label: 'Bizonylatszám',
            defaultSearch: true,
          },
           {
            type: 'text',
            name: 'cm_delivery_note_number',
            label: 'CM szlev szám',
          },
          {
            type: 'text',
            name: 'stowage',
            label: 'Rakodási lista',
          },
          {
            type: 'text',
            name: 'representative_order',
            label: 'Megrendelés',
          },
          {
            type: 'select',
            options: [
              {
                label: 'Bevételezésre vár',
                status: 'waiting-for-inward'
              },
              {
                label: 'Teljesítve',
                status: 'done'
              },
            ],
            name: 'status',
            label: 'Státusz',
            labelCallback: status => status.label,
            valueKey: 'status',
          },
          {
            type: 'select',
            options: users,
            name: 'customer_id',
            label: 'Vevő',
            labelCallback: user => user && `${user.last_name} ${user.first_name} (@${user.username})` || '',
            valueKey: 'id',
          },
        ];
      },
    },
  };
</script>
